import React, { useEffect, useRef, useState } from 'react'
import Wrapper from '../../components/Wrapper'
import { telecomunication, group, short, input } from '../../translate'
import { useParams, useNavigate } from 'react-router-dom'
import { Paper, Box, Typography, IconButton, Alert, TextField, Grid, Button, Popper, Select, MenuItem, FormControl, InputLabel, ListSubheader } from '@mui/material'
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew'
import InfoIcon from '@mui/icons-material/Info'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPenToSquare, faTrashCan } from '@fortawesome/free-solid-svg-icons'
import TelegramInclude from '../../components/new_component/TelegramInclude'
import TelegramCode from '../../components/TelegramCode'
import TelegramEmail from '../../components/TelegramEmail'
import Api from '../../Api'
import { toast } from 'react-toastify'
import { QRCodeSVG } from 'qrcode.react'
export default function TelegramInteg() {
  const { type } = useParams()
  const langIndex = +localStorage.getItem('atsLang') || 1
  const navigate = useNavigate()
  const [mainData, setMainData] = useState([])
  const [forwardEmployees, setForwardEmployees] = useState([])
  const [forwardGroups, setForwardGroups] = useState([])
  const [loading, setLoading] = useState(true)
  const [mainForm, setMainForm] = useState({
    operator: '4',
    note: '',
    ord: 1,
    caller_visible_type: 0,
    no_action: '',
    phone: '',
    profile: '',
    serverHost: '',
    username: '',
    password: '',
    forward: '',
    line: '1'
  })
  const [savingMain, setSavingMain] = useState(false)
  const [telegram, setTelegram] = useState('')
  const [isEmail, setIsEmail] = useState('')
  const [session, setSession] = useState('')
  const [storage, setStorage] = useState('')
  const [loader, setLoader] = useState(false)
  const [editingId, setEditingId] = useState(null)
  const [qrAnchorEl, setQrAnchorEl] = useState(null)
  const qrCloseTimeoutRef = useRef(null)

  const botUsername = '@siptg'
  const botUrl = 'https://t.me/siptg'

  const handleQrOpen = (e) => {
    if (qrCloseTimeoutRef.current) clearTimeout(qrCloseTimeoutRef.current)
    setQrAnchorEl(e.currentTarget)
  }
  const handleQrClose = () => {
    qrCloseTimeoutRef.current = setTimeout(() => setQrAnchorEl(null), 150)
  }
  const handleQrEnter = () => {
    if (qrCloseTimeoutRef.current) clearTimeout(qrCloseTimeoutRef.current)
  }
  const handleQrLeave = () => {
    qrCloseTimeoutRef.current = setTimeout(() => setQrAnchorEl(null), 150)
  }

  const fetchData = async () => {
    if(type === 'main_number') {
      try {
        const [res, empRes, groupsRes] = await Promise.all([
          Api.telegramMain(),
          Api.employeeGetEmployees().catch(() => ({ data: { employees: [] } })),
          Api.groupsGet(1).catch(() => ({ data: { data: [] } })),
        ])
        setMainData(res.data?.data || [])
        setForwardEmployees(empRes?.data?.employees || [])
        setForwardGroups(groupsRes?.data?.data || [])
        setLoading(false)
      } catch (e) {
        setLoading(false)
      }
    }
  }

  const forwardGroupedOptions = (() => {
    const employeeOptions = (forwardEmployees || []).map((e) => ({
      value: String(e.buddy ?? e.id ?? ''),
      label: `${e.buddy ?? e.id ?? ''}${e.notes || e.name ? ` (${e.notes || e.name})` : ''}`
    })).filter((o) => o.value)

    const groupOptions = (forwardGroups || [])
      .filter((g) => g.isivr === 0)
      .map((g) => ({
        value: String(g.virtual ?? ''),
        label: `${g.virtual ?? ''}${g.name ? ` (${g.name})` : ''}`
      }))
      .filter((o) => o.value)

    const voiceMenuOptions = (forwardGroups || [])
      .filter((g) => g.isivr === 1)
      .map((g) => ({
        value: String(g.virtual ?? ''),
        label: `${g.virtual ?? ''}${g.name ? ` (${g.name})` : ''}`
      }))
      .filter((o) => o.value)

    const dedupe = (arr, seen) => arr.filter((o) => {
      if (seen.has(o.value)) return false
      seen.add(o.value)
      return true
    })
    const seen = new Set()
    const employees = dedupe(employeeOptions, seen)
    const groups = dedupe(groupOptions, seen)
    const voiceMenus = dedupe(voiceMenuOptions, seen)

    const hasCurrent = seen.has(String(mainForm.forward || ''))
    const extraCurrent = mainForm.forward && !hasCurrent
      ? [{ value: String(mainForm.forward), label: String(mainForm.forward) }]
      : []

    return { employees, groups, voiceMenus, extraCurrent }
  })()

  useEffect(() => {
    if(type === 'main_number') {
      fetchData()
    }
  }, [type])

  const handleDeleteMain = async (item) => {
    if (!window.confirm(telecomunication.telegram_delete_confirm[langIndex])) {
      return
    }

    try {
      const phoneNumber = `${item.pref}${item.did}`
      await Api.deleteDid(phoneNumber, 4)
      toast.success(telecomunication.telegram_delete_success[langIndex])
      await fetchData()
    } catch (e) {
      toast.error(telecomunication.telegram_delete_error[langIndex])
      console.error(e)
    }
  }

  const handleEditMain = (item) => {
    const phoneNumber = `${item.pref}${item.did}`
    setMainForm({
      operator: item.operator || '4',
      note: item.notes || '',
      ord: item.ord || 1,
      caller_visible_type: item.caller_visible_type || 0,
      no_action: item.no_action || '',
      phone: phoneNumber,
      profile: item.profile || '',
      serverHost: item.serverHost || '',
      username: item.username || '',
      password: item.password || '',
      forward: item.redirect_output || item.forward || '',
      line: item.line || '1'
    })
    setEditingId(phoneNumber)
  }

  const handleCancelEdit = () => {
    setMainForm({
      operator: '4',
      note: '',
      ord: 1,
      caller_visible_type: 0,
      no_action: '',
      phone: '',
      profile: '',
      serverHost: '',
      username: '',
      password: '',
      forward: '',
      line: '1'
    })
    setEditingId(null)
  }

  const handleSaveMain = async () => {
    if (!mainForm.phone.trim() || !mainForm.note.trim()) {
      toast.error(telecomunication.telegram_select_error[langIndex])
      return
    }

    try {
      if (+mainForm.operator === 4 && !mainForm.username && !editingId) {
        setLoader(true)
        const {data} = await Api.telegReg(mainForm.phone)
        setTelegram(mainForm.phone)
        setSession(data.session_id)
        setStorage(data.storage_id)
        setLoader(false)
      } else if (+mainForm.operator === 4) {
        setSavingMain(true)
        if (editingId) {
          // Update existing DID
          await Api.editDid({
            ...mainForm,
            phone: mainForm.phone.trim(),
          }, 4, 10, 1)
          toast.success(telecomunication.telegram_create_success[langIndex])
        } else {
          // Create new DID
          await Api.createDid({
            ...mainForm,
            phone: mainForm.phone.trim(),
            username: ''
          }, 10, 1)
          toast.success(telecomunication.telegram_create_success[langIndex])
        }
        handleCancelEdit()
        await fetchData()
        setSavingMain(false)
      }
    } catch (e) {
      toast.error(telecomunication.telegram_create_error[langIndex])
      console.error(e)
      setLoader(false)
      setSavingMain(false)
    }
  }

  useEffect(() => {
    if (telegram === 'success') {
      (async () => {
        if (+mainForm.operator === 4) {
          setSavingMain(true)
          const formData = { ...mainForm }
          try {
            await Api.createDid({
              ...formData,
              phone: formData.phone.trim(),
              username: ''
            }, 10, 1)
            toast.success(telecomunication.telegram_create_success[langIndex])
            handleCancelEdit()
            setTelegram('')
            await fetchData()
          } catch (e) {
            setTelegram('')

            toast.error(telecomunication.telegram_create_error[langIndex])
            console.error(e)
          } finally {
            setTelegram('')

            setSavingMain(false)
          }
        }
      })()
    }
  }, [telegram])


  const mainNumbers = () => {
    // if (loading) return <Typography>Loading...</Typography>

    return (
      <Box sx={{ mt: 3 }}>
        <Alert 
          icon={<InfoIcon />} 
          severity="success" 
          sx={{ mb: 3 }}
        >
          <Typography variant="body2">
            {telecomunication.telegram_main_number_desc[langIndex]}
          </Typography>
        </Alert>

        <Box sx={{ mb: 4 }}>
          <Paper sx={{ p: 2, border: '1px solid #7ebc0a' }}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label={telecomunication.telegram_phone_number[langIndex]}
                  value={mainForm.phone}
                  onChange={(e) => setMainForm({ ...mainForm, phone: e.target.value })}
                  placeholder={telecomunication.telegram_phone_placeholder[langIndex]}
                  InputProps={{
                    readOnly: !!editingId
                  }}
                  sx={{ 
                    '& .MuiOutlinedInput-root': {
                      '& fieldset': {
                        borderColor: '#7ebc0a',
                      },
                      '&:hover fieldset': {
                        borderColor: '#6aa309',
                      },
                      '&.Mui-focused fieldset': {
                        borderColor: '#7ebc0a',
                      },
                    },
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label={telecomunication.telegram_name_label[langIndex]}
                  value={mainForm.note}
                  onChange={(e) => setMainForm({ ...mainForm, note: e.target.value })}
                  placeholder={telecomunication.telegram_name_placeholder[langIndex]}
                  sx={{ 
                    '& .MuiOutlinedInput-root': {
                      '& fieldset': {
                        borderColor: '#7ebc0a',
                      },
                      '&:hover fieldset': {
                        borderColor: '#6aa309',
                      },
                      '&.Mui-focused fieldset': {
                        borderColor: '#7ebc0a',
                      },
                    },
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label={telecomunication.telegram_line_label[langIndex]}
                  type="number"
                  value={mainForm.line}
                  onChange={(e) => setMainForm({ ...mainForm, line: e.target.value })}
                  placeholder={telecomunication.telegram_line_placeholder[langIndex]}
                  sx={{ 
                    '& .MuiOutlinedInput-root': {
                      '& fieldset': {
                        borderColor: '#7ebc0a',
                      },
                      '&:hover fieldset': {
                        borderColor: '#6aa309',
                      },
                      '&.Mui-focused fieldset': {
                        borderColor: '#7ebc0a',
                      },
                    },
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                  <InputLabel>{telecomunication.telegram_redirect_label[langIndex]}</InputLabel>
                  <Select
                    value={mainForm.forward}
                    onChange={(e) => setMainForm({ ...mainForm, forward: e.target.value })}
                    label={telecomunication.telegram_redirect_label[langIndex]}
                    sx={{ 
                      '& .MuiOutlinedInput-root': {
                        '& fieldset': {
                          borderColor: '#7ebc0a',
                        },
                        '&:hover fieldset': {
                          borderColor: '#6aa309',
                        },
                        '&.Mui-focused fieldset': {
                          borderColor: '#7ebc0a',
                        },
                      },
                    }}
                  >
                    <MenuItem value="">{input.select?.[langIndex] || 'Select'}</MenuItem>
                    {forwardGroupedOptions.extraCurrent.map((opt) => (
                      <MenuItem key={`current-${opt.value}`} value={opt.value}>{opt.label}</MenuItem>
                    ))}

                    {forwardGroupedOptions.employees.length > 0 && (
                      <ListSubheader sx={{ backgroundColor: '#e5e7eb', color: '#374151', fontWeight: 600 }}>
                        {group.employee_section?.[langIndex] || 'Employees'}
                      </ListSubheader>
                    )}
                    {forwardGroupedOptions.employees.map((opt) => (
                      <MenuItem key={`emp-${opt.value}`} value={opt.value}>{opt.label}</MenuItem>
                    ))}

                    {forwardGroupedOptions.groups.length > 0 && (
                      <ListSubheader sx={{ backgroundColor: '#e5e7eb', color: '#374151', fontWeight: 600 }}>
                        {short.group?.[langIndex] || 'Groups'}
                      </ListSubheader>
                    )}
                    {forwardGroupedOptions.groups.map((opt) => (
                      <MenuItem key={`grp-${opt.value}`} value={opt.value}>{opt.label}</MenuItem>
                    ))}

                    {forwardGroupedOptions.voiceMenus.length > 0 && (
                      <ListSubheader sx={{ backgroundColor: '#e5e7eb', color: '#374151', fontWeight: 600 }}>
                        {short.ivr_lists?.[langIndex] || 'Voice menus'}
                      </ListSubheader>
                    )}
                    {forwardGroupedOptions.voiceMenus.map((opt) => (
                      <MenuItem key={`ivr-${opt.value}`} value={opt.value}>{opt.label}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
                {editingId && (
                  <Button
                    variant="outlined"
                    onClick={handleCancelEdit}
                    sx={{ 
                      borderColor: '#7ebc0a',
                      color: '#7ebc0a',
                      '&:hover': {
                        borderColor: '#6aa309',
                        backgroundColor: 'rgba(126, 188, 10, 0.1)'
                      }
                    }}
                  >
                    Cancel
                  </Button>
                )}
                <Button
                  variant="contained"
                  onClick={handleSaveMain}
                  disabled={savingMain || loader || !mainForm.phone.trim() || !mainForm.note.trim()}
                  sx={{ 
                    backgroundColor: '#7ebc0a',
                    color: 'white',
                    '&:hover': {
                      backgroundColor: '#6aa309'
                    },
                    '&.Mui-disabled': {
                      backgroundColor: '#e0e0e0'
                    }
                  }}
                >
                  {loader ? 'Loading...' : telecomunication.telegram_save_button?.[langIndex] || 'Save'}
                </Button>
              </Grid>
            </Grid>
          </Paper>
        </Box>

        <Box>
          {mainData.length > 0 ? (
            <div className="short-cards">
              {mainData.map((item, index) => (
                <Paper key={index} className="short-card" elevation={0}>
                  <div className="short-card__label">
                    {item.notes || `${item.pref}${item.did}`}
                  </div>
                  <div className="short-card__code">
                    <Box component="span" sx={{ display: 'block', mb: 0.5 }}>
                      {telecomunication.telegram_phone_number[langIndex]}: {`${item.pref}${item.did}`}
                    </Box>
                    {item.redirect_output && (
                      <Box component="span" sx={{ display: 'block' }}>
                        {telecomunication.telegram_redirect_label[langIndex]}: {item.redirect_output}
                      </Box>
                    )}
                  </div>
                  <div className="short-card__actions">
                    <span />
                    <Box component="span" sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                      <span
                        onClick={() => handleEditMain(item)}
                        className="edit"
                        title={telecomunication.telegram_save_button?.[langIndex] || 'Edit'}
                        style={{ margin: 0, marginRight: 12 }}
                      >
                        <FontAwesomeIcon icon={faPenToSquare} />
                      </span>
                      <span
                        onClick={() => handleDeleteMain(item)}
                        className="delete"
                        style={{ color: '#ce405f', cursor: 'pointer', margin: 0, fontSize: 16 }}
                        title={telecomunication.telegram_delete_confirm?.[langIndex] || 'Delete'}
                      >
                        <FontAwesomeIcon icon={faTrashCan} />
                      </span>
                    </Box>
                  </div>
                </Paper>
              ))}
            </div>
          ) : (
            <Typography variant="body2" color="text.secondary">
              {telecomunication.telegram_no_integrations[langIndex]}
            </Typography>
          )}
        </Box>
      </Box>
    )
  }
  return (
    <Wrapper>
        <div className="tableParent">
            <Paper sx={{ p: 3 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <IconButton size="small" sx={{ color: '#7ebc0a', fontSize: 18 }} onClick={() => navigate(-1)} aria-label="Back">
                        <ArrowBackIosNewIcon sx={{ fontSize: 20, fontWeight: 700 }} />
                    </IconButton>
                    <Typography variant="h5" sx={{ fontWeight: 700, m: 0 }}>
                        {type === 'included_number' ? telecomunication.telegram_included_number[langIndex] : telecomunication.telegram_main_number[langIndex]}
                    </Typography>
                    {type === 'included_number' && (
                      <>
                        <IconButton
                          size="small"
                          onMouseEnter={handleQrOpen}
                          onMouseLeave={handleQrClose}
                          aria-label="Telegram bot QR"
                          sx={{ color: '#7ebc0a', '&:hover': { backgroundColor: '#7ebc0a15' } }}
                        >
                          <InfoOutlinedIcon fontSize="small" />
                        </IconButton>
                        <Popper
                          open={Boolean(qrAnchorEl)}
                          anchorEl={qrAnchorEl}
                          placement="bottom-start"
                          modifiers={[{ name: 'offset', options: { offset: [0, 8] } }]}
                        >
                          <Box
                            onMouseEnter={handleQrEnter}
                            onMouseLeave={handleQrLeave}
                            sx={{
                              p: 1.5,
                              bgcolor: 'background.paper',
                              border: '1px solid #e5e7eb',
                              borderRadius: 2,
                              boxShadow: 6,
                              width: 220,
                            }}
                          >
                            <Box sx={{ display: 'flex', justifyContent: 'center', mb: 1 }}>
                              <QRCodeSVG value={botUrl} size={160} />
                            </Box>
                            <Typography variant="subtitle2" sx={{ fontWeight: 700, textAlign: 'center' }}>
                              {botUsername}
                            </Typography>
                            <Typography variant="caption" color="text.secondary" sx={{ display: 'block', textAlign: 'center' }}>
                              {botUrl}
                            </Typography>
                          </Box>
                        </Popper>
                      </>
                    )}
                </Box>
                {type === 'included_number' && <TelegramInclude botUrl={botUrl} botUsername={botUsername} />}
                {type === 'main_number' && mainNumbers()}
            </Paper>
        </div>
        {telegram && session ?
          <TelegramCode 
            setIsEmail={setIsEmail} 
            open={telegram} 
            setOpen={setTelegram} 
            session={session}
            setSession={setSession} 
            storage={storage} 
            setStorage={setStorage}
            setFilter={setMainForm}
          /> : null}
        {isEmail ? 
          <TelegramEmail 
            open={isEmail} 
            setOpen={setIsEmail} 
            session={session} 
            setSession={setSession}
            storage={storage} 
            setStorage={setStorage} 
            setFilter={setMainForm}
            setTelegram={setTelegram}
          /> : null}
    </Wrapper>
  )
}
